import categoriesAPI from '@/api/categories'

export const setCategories = ({ commit }, categoryId) => {
  return new Promise((resolve, reject) => {
    categoriesAPI.getCategoriesById(categoryId, results => {
      if (results.data.status === 'success') {
        commit('setCategoriesCurrentId', categoryId)
        commit('setCategoriesList', results.data.data.categories)
        resolve(results)
      } else {
        reject(new Error('Error'))
      }
    })
  })
}

export const setCategoriesCurrentId = ({ commit }, categoryId) => {
  commit('setCategoriesCurrentId', categoryId)
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/actions.js